import React, { Fragment } from "react";
import { withStyles, Button } from "@material-ui/core";
import RestoreIcon from "@material-ui/icons/Restore";
import styles from "../../styles";
import StemMilesGrid from "./StemMiles";
import ZoneMilesGrid from "./ZoneMiles";
import { withUserProfile } from "../../../../../userProfile/userProfileContext";
import { compose } from "recompose";

const SpeedProfiler = props => {
        const { classes } = props;
        return (
            <Fragment>
                <header className={classes.moduleHeader}  data-automationid="speedProfiler-title"> Speed Profiler </header>
                <div className={classes.moduleContainer}>
                    <div className={classes.moduleMessage}>
                        Stem and Zone speeds can be adjusted here. Note: Optimization results will be affected.
                    </div>
                    <StemMilesGrid terminalID={props.userData.userProfile.terminal.id} />
                    <ZoneMilesGrid terminalID={props.userData.userProfile.terminal.id} />
                    <div >
                        <Button color="primary" variant="contained" size="small" classes={{root: classes.actionButton, disabled:classes.actionDisabled}} disabled>
                           <RestoreIcon classes={{root: classes.restoreIcon}} /> Restore to Defaults
                        </Button>
                    </div>
                </div>
            </Fragment>
        )
}
export default compose(withStyles(styles), withUserProfile)(SpeedProfiler);